{
  "datatable": {
    "rowsPerPage": "Строк на странице"
  },
  "department": {
    "addDepartment": "Добавить Департамент",
    "confirms": {
      "deleteText": "Все пользователи, процедуры, учебные объекты, исследования и устройства этого департамента будут перенесены в выбранный ниже департамент. Это действие невозможно отменить.",
      "deleteTitle": "Удалить {name}?",
      "restoreText": "Это сделает департамент снова видимым и восстановит доступ для его персонала.",
      "restoreTitle": "Восстановить {name}?"
    },
    "createNewDepartment": "Создать Новый Департамент",
    "deletedDepartment": "Департамент удален",
    "deleteDepartment": "Удалить департамент",
    "departmentAdmin": "Администратор Департамена",
    "departmentName": "Название Департамента",
    "institution": "Название Учреждения",
    "institutionName": "Название Учреждения",
    "noReassignmentTarget": "Это единственный департамент в учреждении. Создайте другой департамент перед удалением этого.",
    "reassignTo": "Перенести в департамент",
    "restore": "Восстановить",
    "restoredDepartment": "Департамент восстановлен",
    "searchDepartments": "Поиск департамента",
    "showArchived": "Показать архивные департаменты",
    "thisFieldIsRequired": "Обязательное Поле"
  },
  "general": {
    "accessDenied": "Нет Доступа",
    "add": "Дообавить",
    "back": "Назад",
    "cancel": "Отмена",
    "close": "Закрыть",
    "dateAdded": "Добавлено",
    "dateUpdated": "Обновлено",
    "delete": "Удалить",
    "edit": "Редактировать",
    "loading": "Загрузка ...",
    "no": "Нет",
    "noData": "Нет Данных",
    "ok": "ОК",
    "remove": "Удалить",
    "save": "Сохранить",
    "selectAll": "Выбрать Все",
    "yes": "Да",
    "selectGender": "Выбрать пол",
    "gender": {
      "male": "Мужской",
      "female": "Женский"
    },
    "action": "Действие",
    "created": "Создано",
    "updated": "Обновлено",
    "deleted": "Удалено",
    "enabled": "Включено",
    "noHistory": "История отсутствует"
  },
  "institution": {
    "accessRevoked": "Ваше учреждение было удалено. Вы вышли из системы.",
    "confirms": {
      "deleteText": "Это скроет учреждение и его отделения из панели администратора и немедленно отменит доступ для всего персонала. Это можно отменить, восстановив учреждение.",
      "deleteTitle": "Удалить {name}?",
      "restoreText": "Это сделает учреждение и его отделения снова видимыми и восстановит доступ для персонала.",
      "restoreTitle": "Восстановить {name}?"
    },
    "contact": "Контакт",
    "createNewInstitution": "Создать новое учреждение",
    "deletedInstitution": "Учреждение удалено",
    "deleteInstitution": "Удалить учреждение",
    "name": "Имя",
    "region": "Регион",
    "restore": "Восстановить",
    "restoredInstitution": "Учреждение восстановлено",
    "searchInstitutions": "Поиск учреждений",
    "showArchived": "Показать архивные учреждения",
    "switch": "Переключить",
    "switchedTo": "Учреждение изменено на",
    "unableToSwitch": "Невозможно переключить"
  },
  "menu": {
    "categories": "Категории",
    "departments": "Департаменты",
    "home": "Главная",
    "institutions": "Institutions",
    "procedure": "Процедура",
    "procedures": "Процедуры",
    "manageProcedures": "Управление процедурами",
    "manageCategories": "Управление категориями",
    "scheduling": "Расписание",
    "users": "Пользователи"
  },
  "device": {
    "udi": "UDI"
  },
  "procedure": {
    "allSteps": "Все Шаги",
    "authors": "Автор(ы)",
    "category": "Категория",
    "createNewStep": "Создать Новый Шаг",
    "defineFeedback": "Оставить обратную связь",
    "description": "Описание",
    "disableProcedure": "Отключить Процедуру",
    "addProceduresInformation": "Добавить Информацию о Процедуре",
    "editProceduresInformation": "Редактировать Информацию о Процедуре",
    "duplicateStartEndStepWarning": "Допускается только 1 начальный и 1 конечный шаг",
    "information": "Информация",
    "language": "Язык",
    "languagesAvailable": "Доступные языки",
    "media": "Медиа",
    "name": "Имя",
    "owner": "Владелец",
    "procedureCategory": "Категория Процедуры",
    "procedureLanguage": "Язык Процедуры",
    "procedureName": "Имя Процедуры",
    "procedureNotFound": "Процедура не найдена",
    "public": "Общая",
    "publicPrivate": "Общие/Внутренние",
    "revisionHistory": "История Ревизий",
    "searchSteps": "Искать шаг(и)",
    "seeFeedback": "Смотреть обратную связь",
    "statistics": "Статистика",
    "step": "Шаг",
    "thisFieldIsRequired": "Обязательное поле",
    "unableToLoad": "Ошибка во время загрузки процедур",
    "viewAs": "Смотреть Как",
    "checklist": "Контрольный список",
    "status": "Статус",
    "revisionDate": "Дата",
    "revisionUser": "Пользователь",
    "revisionChanges": "Изменения",
    "revisionStepAdded": "добавлен",
    "revisionStepRemoved": "удалён",
    "revisionStepUpdated": "обновлён",
    "revisionStepReordered": "порядок изменён"
  },
  "procedures": {
    "addProcedure": "Добавить процедуру",
    "category": "Категория",
    "deleteProcedure": "Удалить процедуру",
    "department": "Департамент",
    "filter": "Фильтр",
    "private": "Внутренние",
    "procedures": "Процедуры",
    "public": "Общие",
    "publicPrivate": "Общие/Внутренние",
    "searchProcedures": "Поиск процедур",
    "sort": "Сортировать"
  },
  "step": {
    "addDescription": "Добавить Описание",
    "addParentStep": "Добавить родительский шаг",
    "chooseParentSep": "Выберите Родительский Шаг",
    "chooseStepOption": "Выберите вариант шага",
    "chooseTransitionType": "Выберите тип перехода",
    "chooseType": "Выберите тип",
    "description": "Описание",
    "dropFilesOrClickToUpload": "Перетащите файлы сюда или нажмите Загрузить",
    "editStep": "Редактировать Шаг",
    "insertMaxValue": "Введите МАКС значение",
    "insertMinValue": "Введите МИН значение",
    "insertOption": "Вариант ввода",
    "option": "Опция",
    "owner": "Владелец",
    "parentStep": "Родительский Шаг",
    "previousStep": "Предыдущий Шаг",
    "saveMedia": "Сохранить Медиа",
    "stepMedia": "Медиафайлы Шага",
    "transitionToNextStep": "Переход на следующий шаг",
    "transitionType": "Тип Перехода",
    "type": "Тип",
    "value": "Значение",
    "viewInProcedure": "Смотреть в Процедуре",
    "error": {
      "WONT_REACH_END": "Нет пути до КОНЦА",
      "EXIT_NOT_IN_USE": "Неиспользуемый выход",
      "NO_PARENT_SET": "Нет предыдущего шага",
      "PARENT_NOT_EXITS": "Указанный родительский шаг не существует",
      "DUPLICATE_START": "Процедура может содержать только один шаг НАЧАЛО",
      "DUPLICATE_END": "Процедура может содержать только один шаг КОНЕЦ",
      "NO_START": "В процедуре отсутствует шаг НАЧАЛО",
      "NO_END": "В процедуре отсутствует шаг КОНЕЦ",
      "MULTIPLE_CHILDREN_FOR_EXIT": "Выход используется более чем одним шагом"
    }
  },
  "user": {
    "accountSettings": "Настройки аккаунта",
    "chooseUserRole": "Выберите Роль Пользователя",
    "contact": "Контакт",
    "contactInformation": "Контактная информация",
    "dateOfBirth": "Дата Рождения",
    "department": "Департамент",
    "emails": "Емейл Пользователя",
    "emailsDescription": "Введите 1 или более емейл адресов, разделенных точкой с запятой. Пользователю будет отправлено приглашение зарегестрироваться с выбранной ролью на емейл.",
    "filter": "Фильтр",
    "gender": "Пол",
    "institution": "Учреждение",
    "institutionalAdmin": "Администратор Учреждения",
    "institutionAndDepartment": "Учреждение и Департамент",
    "inviteUsers": "Пригласить Пользователя",
    "logOut": "Выйти",
    "nurse": "Медсестра",
    "password": "Пароль",
    "patient": "Пациент",
    "resetPassword": "Сбросить Пароль",
    "resetRequestSentTo": "Письмо с данными о сбросе паролья отправлен на",
    "searchUsers": "Поиск пользователя",
    "sendResetPasswordEmailTo": "Отправить письмо с данными о сбросе пароля на",
    "sort": "Сортировка",
    "subscription": "Подписка",
    "thisFieldIsRequired": "Обязательное поле",
    "user": "Пользователь",
    "userDetailsUpdated": "Данные о пользователе обновлены",
    "userInformation": "Пользовательская информация",
    "userRole": "Роль Пользователя"
  },
  "approvalRequest": {
    "actionType": "Action Type",
    "requestedBy": "Requested By",
    "approvedBy": "Approved By",
    "confirms": {
      "approveTitle": "Approve request",
      "approveText": "Are you sure you want to approve this request?",
      "rejectTitle": "Reject request",
      "rejectText": "Please provide a reason for rejecting this request.",
      "rejectReasonPlaceholder": "Rejection reason"
    },
    "actionTypes": {
      "PERMISSION_GRANT": "Permission Grant",
      "PERMISSION_REVOKE": "Permission Revoke",
      "EXPORT_VISITS": "Export Visits",
      "EXPORT_LOCATION_HISTORY": "Export Location History",
      "EXPORT_ARRIVAL_HISTORY": "Export Arrival History",
      "ENABLE_USER": "Enable User",
      "DISABLE_USER": "Disable User"
    },
    "toasts": {
      "created": "Approval request created",
      "applied": "Action applied",
      "applyFailed": "Failed to apply action",
      "approved": "Request approved",
      "approveFailed": "Failed to approve request",
      "rejected": "Request rejected",
      "rejectFailed": "Failed to reject request"
    }
  },
  "patients": {
    "standingAssignment": "Постоянное назначение",
    "noStandingAssignment": "Нет постоянного назначения",
    "unknownNurse": "Назначенная медсестра (имя недоступно)",
    "standingAssignmentHelperText": "В качестве постоянного назначения можно выбрать только пользователей с ролью «Home Nurse».",
    "changeStandingAssignment": "Изменить назначение",
    "clearStandingAssignment": "Снять назначение",
    "confirmClearStandingAssignmentText": "Вы уверены, что хотите снять постоянное назначение для этого пациента?",
    "standingAssignmentLabel": "{name} (постоянное)",
    "onShiftLabel": "{name} (на смене)",
    "currentlyOnShiftWith": "Сейчас на смене с",
    "notCurrentlyOnShift": "Сейчас не на смене",
    "visitName": "Название",
    "visitDate": "Дата",
    "performedBy": "Выполнил(а)",
    "status": "Статус",
    "location": "Местоположение / палата (необязательно)",
    "enterLocation": "Введите местоположение или номер палаты",
    "admissionDate": "Дата поступления (необязательно)",
    "dischargeDate": "Дата выписки (необязательно)",
    "acuity": "Степень тяжести (необязательно)",
    "unsupportedFieldsNotice": "Аллергия, медикаменты, рост, вес, тип пациента и код/название состояния не поддерживаются этим импортом — добавьте их вручную после импорта.",
    "import": {
      "importSucceeded": "Импортировано пациентов: {created}, пропущено дубликатов: {duplicates}.",
      "departmentsLoadFailed": "Не удалось загрузить отделения. Пожалуйста, попробуйте снова."
    }
  },
  "errors": {
    "UNKNOWN_ERROR": "Неизвестная ошибка"
  },
  "titles": {
    "categories": "Категории",
    "visitreport": "Отчёт о визите"
  },
  "toasts": {
    "patientAdded": "Пациент успешно добавлен",
    "patientUpdated": "Данные пациента успешно обновлены",
    "procedureAdded": "Процедура успешно добавлена",
    "procedureUpdated": "Процедура успешно обновлена",
    "procedureDeleted": "Процедура успешно удалена",
    "visitAdded": "Визит успешно добавлен",
    "visitUpdated": "Визит успешно обновлён",
    "visitDeleted": "Визит успешно удалён"
  },
  "studyResults": {
    "user": "Пользователь",
    "department": "Отдел",
    "study": "Исследование",
    "date": "Дата",
    "survey": "Опрос",
    "results": "Результаты",
    "studyResults": "Результаты исследования",
    "surveyResults": "Результаты опроса",
    "list": "Список",
    "graph": "График",
    "surveyStartDate": "Начало опроса",
    "surveyEndDate": "Окончание опроса",
    "userResults": "Результаты пользователя",
    "question": "Вопрос",
    "questionType": "Тип вопроса",
    "answer": "Ответ",
    "position": "Позиция",
    "scaleAnswerFormat": "{value} — {meaning}"
  },
  "visitReport": {
    "consent": "Согласие",
    "viewConsent": "Просмотреть согласие",
    "homeVisit": "Визит на дом",
    "recomendationForTreatment": "Рекомендации по лечению, уходу, труду и амбулаторному наблюдению",
    "anamnesis": "Анамнез",
    "answerType": "Тип ответа",
    "contactPhone": "Контактный телефон",
    "contactEmail": "Контактный email",
    "visitMadeBy": "Визит выполнил(а)",
    "homeVisitTime": "Время визита на дом",
    "visitForm": "Форма визита",
    "viewHistory": "Просмотреть историю",
    "patientsPrimaryHealthConcern": "Основная жалоба пациента",
    "conditionAssesmentInformation": "Информация об оценке состояния",
    "bloodPressure": "Артериальное давление",
    "measurement": "Измерение",
    "BMI": "ИМТ",
    "diagnosis": "Диагноз",
    "appliedMedicalTreatments": "Применённое медикаментозное лечение",
    "appliedTreatment": "Применённое лечение",
    "descriptionOfTestsConsultationPlans": "Описание анализов/планов консультаций",
    "instrumentalTests": "Инструментальные исследования",
    "laboratoryTests": "Лабораторные исследования",
    "appliedMedicalTreatment": "Применённое медицинское лечение",
    "specialist": "Специалист",
    "status": "Статус",
    "complaintData": "Данные жалобы",
    "pulse": "Пульс",
    "viewFullVisitForm": "Просмотреть полную форму визита",
    "height": "Рост",
    "weight": "Вес"
  },
  "category": {
    "addCategory": "Добавить категорию",
    "confirms": {
      "deleteTitle": "Удалить {name}?",
      "deleteTextImmediate": "В этой категории нет процедур, её можно удалить сразу. Это действие невозможно отменить.",
      "chooseReassignMode": "В этой категории всё ещё есть процедуры. Выберите, как переназначить их перед удалением.",
      "deleteTextAllAtOnce": "Выберите категорию, в которую будут перенесены все процедуры. Это действие невозможно отменить.",
      "deleteTextOneByOne": "Просмотрите процедуры ниже, затем выберите категорию, в которую они все будут перенесены.",
      "affectedProcedures": "Процедуры, которые будут перенесены",
      "stillHasProcedures": "В этой категории всё ещё есть назначенные процедуры. Пожалуйста, выберите целевую категорию."
    },
    "deletedCategory": "Категория удалена",
    "editCategory": "Редактировать категорию",
    "frequency": "Частота",
    "reassignAllAtOnce": "Переназначить все процедуры сразу",
    "reassignOneByOne": "Переназначить по одной",
    "reassignTo": "Переназначить на",
    "searchCategories": "Поиск категорий",
    "updatedCategory": "Категория обновлена"
  }
}
